import { Button } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { useResetPasswordNavigation } from 'hooks';
import { Trans, useTranslation } from 'react-i18next';
import { PiConfetti } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ResetPasswordConfirmation = () => {
  const { t } = useTranslation();

  const { goToLogin, email } = useResetPasswordNavigation();

  return (
    <PublicPage
      creative={
        <div
          className='flex flex-col h-full w-96 gap-10 p-30 justify-center items-center '
          style={{
            backgroundColor: 'var(--secondary-soft)',
            color: 'var(--primary)',
          }}>
          <PiConfetti size={50} />
          <p className='text-center'>
            <Trans
              i18nKey='reset-password-confirmation.message'
              values={{ email: email }}
              components={{ strong: <strong /> }}
            />
          </p>
          <Button variant={BUTTON_VARIANT.submit} onClick={goToLogin}>
            <Button.Text text={t('reset-password-confirmation.button')} />
          </Button>
        </div>
      }
    />
  );
};

export default ResetPasswordConfirmation;
